import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { ScrollProgress, CursorGlow } from "@/components/effects";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import ProcessTimeline from "@/components/sections/ProcessTimeline";
import About from "@/components/sections/About";
import Technologies from "@/components/sections/Technologies";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

function App() {
  return (
    <div className="grain relative bg-brand-bg text-white font-body min-h-screen overflow-x-hidden">
      <ScrollProgress />
      <CursorGlow />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Services />
        <WhyChooseUs />
        <ProcessTimeline />
        <About />
        <Technologies />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
